/* eslint-disable import/prefer-default-export */
import { curry } from 'ramda';

const calculateOffset = curry((currentPage, limit) => (currentPage - 1) * limit);

export { calculateOffset };
